<template>
  <div>
    <div class="stock-control">
      <div class="d-flex flex-wrap align-items-center mb-3 stock-header">
        <div class="color-common stock-header__title">
          <h3 class="title-page mb-0 ps-3">
            BRANCH -
            {{ physicalBranch?.name }}
          </h3>
          <h3 class="title-page mb-0 ps-3">{{ title }}</h3>
        </div>
        <div class="d-flex align-items-center control-type ms-3 stock-header__tabs">
          <material-button
            @click="changeTab(2)"
            class="mx-2 btn-background btn-sm d-flex flex-column"
            :class="{ active: type === ORDER }"
          >
            <i class="material-icons-round"> toc </i>
            Order
          </material-button>
          <material-button
            @click="onKdsTabClick"
            class="mx-2 btn-background btn-sm d-flex flex-column"
            :class="{ active: type === KDS }"
          >
            <i class="material-icons-round"> kitchen </i>
            KDS
          </material-button>
          <material-button
            @click="changeTab(1)"
            class="mx-2 btn-background btn-sm d-flex flex-column"
            :class="{ active: type === STOCK }"
          >
            <i class="material-icons-round">inventory_2</i>
            Stock
          </material-button>
        </div>
      </div>
      <StockManagement
        v-if="type === STOCK"
        :showLoader="showLoader"
        :hideLoader="hideLoader"
        :showNotification="showNotification"
        :getPhysicalBranch="getPhysicalBranch"
        :requirePasscode="requirePasscode"
        :handlePasscodeRequired="handlePasscodeRequired"
      />
      <OrderManagement
        v-if="type === ORDER && canOpenGatedTab"
        :showLoader="showLoader"
        :hideLoader="hideLoader"
        :showNotification="showNotification"
        :getPhysicalBranch="getPhysicalBranch"
        :requirePasscode="requirePasscode"
        :handlePasscodeRequired="handlePasscodeRequired"
      />
      <div v-if="type === KDS && !token" class="kds-signin">
        <i class="material-icons-round kds-signin__icon">lock</i>
        <h4 class="kds-signin__title">{{ $t("kdsSignInTitle") }}</h4>
        <p class="kds-signin__body">{{ $t("kdsSignInBody") }}</p>
        <material-button
          class="btn-background btn-sm"
          @click="goToSignIn"
        >
          {{ $t("kdsSignInAction") }}
        </material-button>
      </div>
      <KdsManagement
        v-if="type === KDS && token"
        :showLoader="showLoader"
        :hideLoader="hideLoader"
        :showNotification="showNotification"
        :getPhysicalBranch="getPhysicalBranch"
        :initialPrinterId="initialPrinterId"
        :initialStatus="initialStatus"
        :requirePasscode="requirePasscode"
        :handlePasscodeRequired="handlePasscodeRequired"
      />
    </div>
    <div>
      <button
        style="display: none"
        type="button"
        ref="passcodeModalTrigger"
        data-bs-toggle="modal"
        data-bs-target="#modalCheckStockPasscodePage"
      ></button>
      <div
        class="modal fade"
        id="modalCheckStockPasscodePage"
        ref="passcodeModal"
        tabindex="-1"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">PASSCODE REQUIRED</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label class="control-label" style="margin-left: 0px"
                  ><strong> Please enter passcode to continue.</strong></label
                >
                <div>
                  <material-input
                    v-model="passcodeValue"
                    extraClass="ml-5"
                    placeholder="Enter passcode"
                  />
                  <span class="is-invalid mt-1" v-if="passcodeError">{{
                    passcodeError
                  }}</span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-success btn-background btn-sm"
                @click="submitPasscode"
              >
                Ok
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                data-bs-dismiss="modal"
                @click="cancelPasscode"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- KDS station picker (M1016): asked every time the KDS tab is tapped,
           so a device never lands on "Not Printable" by default. Laid out like
           the Home "KDS Links" popup (ModalListLinks), for this branch only. -->
      <div
        class="modal fade"
        id="modalSelectKdsStation"
        ref="kdsPickerModal"
        tabindex="-1"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t("kdsPickerTitle") }}</h5>
              <i
                class="material-icons kds-picker__close"
                aria-label="Close"
                @click="closeKdsPickerModal"
                >clear</i
              >
            </div>
            <div class="modal-body kds-picker__body">
              <div class="kds-picker__row text-bold kds-picker__branch">
                {{ physicalBranch?.name }}
              </div>
              <div
                v-for="printer in kdsPickerPrinters"
                :key="printer.id"
                class="kds-picker__row"
              >
                <div class="ps-5">{{ printer.nickname || printer.name }}</div>
                <div class="d-flex">
                  <div
                    class="tag-a-custom"
                    @click="selectKdsPrinter(printer.id, 'preparing')"
                  >
                    Preparing
                  </div>
                  <div
                    class="tag-a-custom ms-3"
                    @click="selectKdsPrinter(printer.id, 'ready')"
                  >
                    Ready
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="closeKdsPickerModal"
              >
                {{ $t("kdsPickerCancel") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <material-loading :active="loaderActive" />
    <div class="position-fixed top-1 end-1 z-index-2 message-success" style="z-index: 99999 !important;">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import StockManagement from "./components/StockManagement.vue";
import OrderManagement from "./components/OrderManagement.vue";
import KdsManagement from "./components/KdsManagement.vue";
import { STOCK, ORDER, KDS } from "./mock_data";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import TokenService from "../../services/token.service";
import ItemService from "../../services/product/item.service";
import StockAccessService from "../../services/stock-access.service";
import MenusetService from "../../services/product/menuset.service";

// Printer seeded first in MintyPrinter::PRINTER_NAME; it routes nothing to the
// kitchen, so the picker always lists it last.
const NOT_PRINTABLE = "not printable";

export default {
  name: "stock",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    MaterialInput,
    StockManagement,
    OrderManagement,
    KdsManagement,
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      type: STOCK,
      ORDER,
      STOCK,
      KDS,
      title: "Stock Control",
      physicalBranch: "",
      initialPrinterId: null,
      initialStatus: null,
      token: TokenService.getLocalAccessToken(),
      isPasscodeEnabled: false,
      isPasscodeStateLoaded: false,
      isUnlocked: false,
      passcodeValue: "",
      passcodeError: "",
      pendingAction: null,
      accessTimeout: null,
      kdsPickerPrinters: [],
    };
  },
  created() {
    this.restoreAccess();
    this.loadPasscodeState();

    // Direct KDS link: /physical-branch/kds/:m/:b/:printer_id/:status
    // Force the KDS tab and forward the printer + status hints to the child.
    if (this.$route.name === "KdsDirectLink") {
      this.initialPrinterId = Number(this.$route.params.printer_id);
      this.initialStatus = this.$route.params.status;
      this.changeTab(this.KDS);
      return;
    }
    this.type = Number(this.$route.query.type ?? this.STOCK)
    this.changeTab(this.type)
  },
  mounted() {
    // Cancel covers the button; this covers ESC and any other dismissal, so an
    // abandoned toggle cannot fire later when some other action is unlocked.
    this.$refs.passcodeModal?.addEventListener(
      "hidden.bs.modal",
      this.onPasscodeModalHidden
    );
  },
  beforeUnmount() {
    clearTimeout(this.accessTimeout);
    this.$refs.passcodeModal?.removeEventListener(
      "hidden.bs.modal",
      this.onPasscodeModalHidden
    );
    this.closePasscodeModal();
    this.closeKdsPickerModal();
  },
  methods: {
    // M1016: tapping KDS asks which station this board shows. Signed-out
    // devices still get the sign-in panel, and a re-tap on KDS does nothing.
    onKdsTabClick() {
      if (this.type == KDS) return;

      if (!this.token) {
        this.changeTab(KDS);
        return;
      }

      this.openKdsPicker();
    },

    async openKdsPicker() {
      this.showLoader();
      try {
        const response = await MenusetService.getPrinters({
          merchant_id: this.merchantId,
          physical_branch_id: this.branchId,
        });
        if (!response.data.result.isSuccess) {
          this.showNotification(response.data.result.message, "danger");
          return;
        }

        const printers = response.data.data ?? [];
        if (printers.length <= 1) {
          if (printers.length) {
            this.selectKdsPrinter(printers[0].id, "preparing");
          }
          else this.changeTab(KDS);
          return;
        }

        // Stable sort: only "Not Printable" moves, the rest keep API order.
        this.kdsPickerPrinters = [...printers].sort(
          (a, b) => this.isNotPrintable(a) - this.isNotPrintable(b)
        );
        bootstrap.Modal.getOrCreateInstance(this.$refs.kdsPickerModal).show();
      } catch (error) {
        // KdsManagement owns the 401 → sign-in handling; let it take over.
        if (error?.response?.status === 401) {
          this.changeTab(KDS);
          return;
        }
        this.showNotification(error?.message ?? error, "danger");
      } finally {
        this.hideLoader();
      }
    },

    // Opens the board in place the way the Home Preparing/Ready links do in a
    // new tab: KdsManagement takes printer + status as a direct link.
    selectKdsPrinter(printerId, status) {
      // Direct-link mode skips the last-used write, so keep it in step here.
      localStorage.setItem(this.kdsStorageKey, String(printerId));
      this.initialPrinterId = printerId;
      this.initialStatus = status;
      this.closeKdsPickerModal();
      this.changeTab(KDS);
    },

    closeKdsPickerModal() {
      this.forceHideModal(this.$refs.kdsPickerModal);
    },

    isNotPrintable(printer) {
      return (printer.name ?? "").trim().toLowerCase() === NOT_PRINTABLE;
    },

    changeTab(type) {
      this.type = type;

      if (type == ORDER) {
        this.title = "Order Status";
      } else if (type == KDS) {
        this.title = "Kitchen Display";
      } else {
        this.title = "Stock Control";
      }

      // Order is the one tab held back until the passcode is in: it shows
      // customer names, phone numbers and delivery addresses.
      if (type == ORDER && !this.hasPasscodePermission) {
        this.openPasscodeModal();
      }
    },

    // Does this branch have a passcode at all? One answer for all three tabs,
    // instead of each of them asking on its own.
    loadPasscodeState() {
      ItemService.checkStockPasscodeExists({
        merchantId: this.merchantId,
        branchId: this.branchId,
      })
        .then(
          (response) => {
            this.isPasscodeEnabled =
              response.data?.result?.isSuccess &&
              response.data?.data?.has_passcode == 1;
          },
          () => {
            // Assume it is on: a write the API turns down still reopens the
            // dialog, so the worst case is one extra prompt.
            this.isPasscodeEnabled = true;
          }
        )
        .finally(() => {
          this.isPasscodeStateLoaded = true;

          if (this.type == ORDER && !this.hasPasscodePermission) {
            this.openPasscodeModal();
          }
        });
    },

    // Runs `action` when the page is unlocked, otherwise asks for the passcode
    // first and replays it afterwards.
    requirePasscode(action) {
      if (this.hasPasscodePermission) {
        action();
        return;
      }

      this.pendingAction = action;
      this.openPasscodeModal();
    },

    // Backstop for when the API turns a write down: the hour is up, so ask
    // again and replay what the user was doing.
    handlePasscodeRequired(response, retryAction) {
      if (response?.data?.data?.errorCode !== "PASSCODE_REQUIRED") {
        return false;
      }

      this.lockAccess();
      this.pendingAction = retryAction ?? null;
      this.openPasscodeModal();

      return true;
    },

    submitPasscode() {
      this.passcodeError = "";
      this.showLoader();

      ItemService.checkPasscodeStockPage({
        merchantId: this.merchantId,
        branchId: this.branchId,
        passcode: this.passcodeValue,
      }).then(
        (response) => {
          // A wrong passcode still answers isSuccess, just without a token;
          // isSuccess false means something else, such as the attempt limit.
          if (!response.data.result.isSuccess) {
            this.passcodeError = response.data.result.message;
            this.hideLoader();
            return;
          }

          const access = StockAccessService.save(
            this.merchantId,
            this.branchId,
            response.data.data
          );

          if (!access) {
            this.passcodeError = "Passcode incorrect!";
            this.hideLoader();
            return;
          }

          this.unlockAccess(access);
          this.passcodeValue = "";
          this.closePasscodeModal();
          // Hidden here rather than left to the replayed action: several of them
          // (a bulk with nothing selected, the silent order poll, every KDS
          // action) never call hideLoader, and the overlay would stay up.
          this.hideLoader();
          this.runPendingAction();
        },
        (error) => {
          this.showNotification(error, "danger");
          this.hideLoader();
        }
      );
    },

    onPasscodeModalHidden() {
      if (this.hasPasscodePermission) return;

      this.cancelPasscode();
    },

    cancelPasscode() {
      this.pendingAction = null;
      this.passcodeValue = "";
      this.passcodeError = "";

      // Nothing to show on a locked Order tab, so fall back to Stock.
      if (this.type == ORDER && !this.hasPasscodePermission) {
        this.changeTab(STOCK);
      }
    },

    runPendingAction() {
      const action = this.pendingAction;
      this.pendingAction = null;

      if (action) {
        action();
      }
    },

    restoreAccess() {
      const access = StockAccessService.get(this.merchantId, this.branchId);

      if (access) {
        this.unlockAccess(access);
      }
    },

    unlockAccess(access) {
      this.isUnlocked = true;
      this.passcodeError = "";
      clearTimeout(this.accessTimeout);
      // Re-lock the page the moment the token expires, so no tab offers an
      // action the API is about to turn down.
      this.accessTimeout = setTimeout(
        this.onAccessExpired,
        Math.max(access.expiresAt * 1000 - Date.now(), 0)
      );
    },

    onAccessExpired() {
      // Every accepted request renews the token, so what is in storage may
      // already reach further than the timer that just fired.
      const access = StockAccessService.get(this.merchantId, this.branchId);

      if (access) {
        this.unlockAccess(access);
        return;
      }

      this.lockAccess();

      // Order would otherwise blank out mid shift; ask for the passcode instead.
      if (this.type == ORDER) {
        this.openPasscodeModal();
      }
    },

    lockAccess() {
      clearTimeout(this.accessTimeout);
      this.isUnlocked = false;
      StockAccessService.clear(this.merchantId, this.branchId);
    },

    openPasscodeModal() {
      this.passcodeValue = "";
      this.passcodeError = "";
      this.$refs.passcodeModalTrigger.click();
    },

    closePasscodeModal() {
      this.forceHideModal(this.$refs.passcodeModal);
    },

    forceHideModal(modalEl) {
      if (!modalEl) return;

      const instance = bootstrap.Modal.getInstance(modalEl);
      if (instance) instance.hide();

      // modal-override.js clones backdrops, which breaks Bootstrap's own
      // tracking, so the leftovers are cleared by hand.
      modalEl.classList.remove("show");
      modalEl.style.display = "none";
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("padding-right");
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    },

    goToSignIn() {
      this.$router.push("/sign-in");
    },

    getPhysicalBranch(physicalBranch) {
      this.physicalBranch = physicalBranch;
    },

    showNotification(message, type) {
      this.snackbar = type;
      this.message = message;
      this.setTimeOutNotification();
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  computed: {
    merchantId() {
      return this.$route.params.merchant_id;
    },
    branchId() {
      return this.$route.params.branch_id;
    },
    hasPasscodePermission() {
      return !this.isPasscodeEnabled || !!this.token || this.isUnlocked;
    },
    kdsStorageKey() {
      // Same key KdsManagement reads (kds.selectedPrinterId.<physical branch>).
      return `kds.selectedPrinterId.${this.branchId}`;
    },
    canOpenGatedTab() {
      return this.isPasscodeStateLoaded && this.hasPasscodePermission;
    },
  },
};
</script>

<style scoped>
.stock-control {
  color: #222 !important;
}

/* The kitchen display needs a signed-in device: its printer list and settings
   sit behind the merchant login. Say so plainly instead of letting the board
   load half-empty behind an error dialog. */
.kds-signin {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  padding: 56px 24px;
  color: #133067;
}

.kds-signin__icon {
  font-size: 34px;
  opacity: 0.55;
}

.kds-signin__title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
}

.kds-signin__body {
  margin: 0 0 6px;
  max-width: 42ch;
  font-size: 0.9rem;
  opacity: 0.75;
}

.kds-picker__close {
  cursor: pointer;
}

/* Matches ModalListLinks: fixed-height scrolling body, hairline rows. */
.kds-picker__body {
  min-height: 50vh;
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

.kds-picker__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #ddd;
}

.kds-picker__branch {
  color: #000;
}

.control-type > button > i {
  font-size: 20px !important;
  margin-bottom: 2px;
}

.control-type > button {
  color: #133067 !important;
  border-color: #133067 !important;
}

.control-type > button.active {
  color: #fff !important;
  background-color: #133067 !important;
}

@media (max-width: 768px) {
  .stock-header__tabs {
    margin-left: 0 !important;
    flex-wrap: wrap;
  }

  .stock-header__title h3.title-page {
    font-size: 1.15rem;
  }
}

@media (max-width: 500px) {
  .stock-header {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .stock-header__title {
    width: 100%;
    margin-bottom: 10px;
  }

  .stock-header__tabs {
    width: 100%;
    margin-left: 0 !important;
    flex-wrap: nowrap;
  }

  /* MaterialButton renders its own <button> in a separate SFC, so a plain
     ">" child selector never crosses that component boundary — :deep() is
     required for this to actually reach the rendered button. */
  .stock-header__tabs :deep(.btn) {
    flex: 1 1 0;
    width: auto !important;
    min-width: 0;
    margin-left: 4px !important;
    margin-right: 4px !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
    font-size: 12px;
  }
}
</style>
